<!-- static content data from lang: report -->
<template>
    <div>
        <div class="h-100" v-loading="loading">
            <base-header class="pb-6">
                <div class="row align-items-center pb-4">
                    <div class="col-lg-12 col-12">
                        <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.headerTitle}}</h6>
                        <nav aria-label="breadcrumb" class="d-inline-block ml-4">
                            <route-bread-crumb></route-bread-crumb>
                        </nav>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div>
                    <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <div class="col-md-12">
                        <template v-for="(message) in alertMessages">
                            <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                        </template>
                        <template v-for="(message) in successMessages">
                            <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
                        </template>
                        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                            <form role="form" @submit.prevent="handleSubmit(filterData)">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input
                                                    :label="lang.label.company"
                                                    name="company"
                                                    :rules="{required: true}"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    >
                                                    <el-select
                                                        v-model="model.company"
                                                        autocomplete="off"
                                                        :placeholder="lang.label.selectCompany"
                                                        @change="getSiteList"
                                                        filterable
                                                        :disabled="type == 2 || type == 4 ||type==6"
                                                        >
                                                        <el-option
                                                            v-for="option in company"
                                                            :key="option.Name"
                                                            :label="option.Name"
                                                            :value="option.ID"
                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input
                                                    :label="lang.label.site"
                                                    name="site"
                                                    :rules="{required: true}"
                                                    labelClasses="form-control-label asterisk-mark"
                                                    >
                                                    <el-select
                                                        v-model="model.site"
                                                        autocomplete="off"
                                                        :placeholder="lang.label.selectSite"
                                                        filterable
                                                        multiple
                                                        >
                                                        <el-option
                                                            v-for="option in site"
                                                            :key="option.Name"
                                                            :label="option.Name"
                                                            :value="option.ID"
                                                            ></el-option>
                                                    </el-select>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input class="date-picker" labelClasses="form-control-label asterisk-mark"
                                                            :label="lang.label.fromDateRange" name="From date"
                                                            :rules="{required: true}">
                                                            <flat-picker
                                                        ref="fromDate"
                                                        :config="{disable: [fromDateDisable], disableMobile: 'true', dateFormat: 'd-m-Y', minDate:new Date().fp_incr(-365) ,maxDate: fromMaxDate }"
                                                        class="form-control datepicker"
                                                        v-model="model.fromDate"
                                                        :placeholder="lang.label.selectDate"
                                                        ></flat-picker>
                                                    <div class="flat-calenda-icon">
                                                        <span data-toggle>
                                                            <i class="fas fa-calendar-alt text-primary"></i>
                                                        </span>
                                                    </div>
                                                </base-input>
                                            </div>
                                            <div class="col-md-6">
                                                <base-input class="date-picker" labelClasses="form-control-label asterisk-mark"
                                                            :label="lang.label.toDateRange" name="To date"
                                                            :rules="{required: true}">
                                                            <flat-picker
                                                        ref="toDate"
                                                        :config="{disable: [toDateDisable],disableMobile: 'true', dateFormat: 'd-m-Y', minDate:new Date().fp_incr(-365) ,maxDate:fromMaxDate}"
                                                        class="form-control datepicker"
                                                        v-model="model.toDate"
                                                        :placeholder="lang.label.selectDate"
                                                        ></flat-picker>
                                                    <div class="flat-calenda-icon">
                                                        <span data-toggle>
                                                            <i class="fas fa-calendar-alt text-primary"></i>
                                                        </span>
                                                    </div>
                                                </base-input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mb-3">
                                    <base-button type="primary " native-type="submit">{{lang.label.buttons.filter}}</base-button>
                                </div>
                            </form>
                        </validation-observer>
                    </div>
                    <hr/>
            <div class="col-md-12">
                        <div class="text-right mb-3">
                            <export-excel
                                :data="json_data"
                                :fields="json_fields"
                                worksheet="My Worksheet"
                                name="filename.xls"
                                >
                                <base-button type="success" native-type="submit" :disabled="json_data.length > 0 ? false: true">
                                    {{lang.label.buttons.export}}
                                </base-button>
                            </export-excel>
                            <!-- <base-button type="success" native-type="submit">{{lang.label.buttons.export}}</base-button> -->
                        </div>
                        <div class="text-center text-lg-left">
                            <div class="row">
                                <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                                    <el-select
                                        class="select-primary pagination-select"
                                        v-model="pagination.perPage"
                                        autocomplete="off"
                                        placeholder="Per page"
                                        >
                                        <el-option
                                            class="select-primary"
                                            v-for="item in pagination.perPageOptions"
                                            :key="item"
                                            :label="item"
                                            :value="item"
                                            ></el-option>
                                    </el-select>

                                    <div>
                                        <base-input
                                            v-model="searchQuery"
                                            autocomplete="off"
                                            prepend-icon="fas fa-search"
                                            :placeholder="lang.label.search"
                                            ></base-input>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <el-table
                  :data="queriedData"
                                row-key="id"
                                header-row-class-name="thead-light"
                                @sort-change="sortChange"
                                @selection-change="selectionChange"
                                border
                                >
                                <el-table-column min-width="200px" label="Company Name" prop="CompanyName" sortable></el-table-column>
                                <el-table-column min-width="150px" label="Site Name" prop="SiteName" sortable></el-table-column>
                                <!--<el-table-column min-width="150px" label="Visitor ID" prop="VisitorID" sortable></el-table-column>-->
                                <el-table-column min-width="150px" label="ID/Passport" prop="VisitorID" sortable></el-table-column>
                                <el-table-column min-width="100px" label="Visitor Name" prop="VisitorName" sortable></el-table-column>
                                <!--<el-table-column min-width="100px" label="Surname" prop="Surname" sortable></el-table-column>-->
                                <el-table-column min-width="100px" label="Visitor Surname" prop="Surname" sortable></el-table-column>
                                <el-table-column min-width="100px" label="Member Name" prop="MemberName" sortable></el-table-column>
                                <el-table-column min-width="150px" label="Visitor Email" prop="EmailAddress" sortable></el-table-column>
                                <el-table-column min-width="100px" label="Device Name" prop="DeviceName" sortable></el-table-column>
                                <el-table-column min-width="100px" label="Device Identifier" prop="DeviceIdentifier" sortable></el-table-column>
                                <el-table-column min-width="150px" label="Visitor Remark" prop="VisitorRemark" sortable></el-table-column>
                                <!--<el-table-column min-width="170px" label="Visitor Cell Phone Number" prop="CellphoneNumber"-->
                                <el-table-column min-width="170px" label="Mobile Number" prop="CellphoneNumber"
                                                 sortable></el-table-column>
                                <el-table-column min-width="130px" label="Access Date & Time" sortable prop="AccessDateTime">
                                    <div class="d-flex" slot-scope="scope">
                                        <span>{{scope.row.AccessDateTime}}</span>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="100px" label="Screening Result" prop="BodyTemperature" sortable></el-table-column>
                                <el-table-column min-width="95px" label="Allow share information" prop="AllowShareInformation" sortable></el-table-column>
                                <!-- <el-table-column width="100px" align="right" label="Actions">
                                  <div class="d-flex">
                                    <el-tooltip :content="lang.label.tooltips.delete" placement="bottom">
                                      <base-button
                                        class="btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                        @click.native="showSwal($index, row)"
                                      >
                                        <i class="text-white fas fa-trash-alt"></i>
                                      </base-button>
                                    </el-tooltip>
                                    <el-tooltip :content="lang.label.tooltips.edit" placement="bottom">
                                      <base-button class="btn-link" type="info" size="sm" icon @click="edit()">
                                        <i class="text-white fas fa-pencil-alt"></i>
                                      </base-button>
                                    </el-tooltip>
                                  </div>
                                </el-table-column> -->
                            </el-table>
                        </div>
                        <div class="mt-3 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <div class>
                                <p class="card-category">
                                    {{lang.label.showPagination.showing}} {{ from + 1 }} {{lang.label.showPagination.to}} {{ to }}
                                    {{lang.label.showPagination.of}} {{ total }} {{lang.label.showPagination.entries}}
                                    <span
                                        v-if="selectedRows.length"
                                        >&nbsp; &nbsp; {{selectedRows.length}} {{lang.label.showPagination.rowsSelected}}</span>
                                </p>
                            </div>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                                ></base-pagination>
                        </div>
                    </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import {Table, TableColumn, Select, Option} from "element-ui";
    import flatPicker from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
    import {BasePagination} from "@/components";
    import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
    import {mapGetters} from "vuex";
    import Alert from "@/components/BaseAlert.vue";
    var moment = require('moment');
    import excel from 'vue-excel-export'

            Vue.use(excel)
    export default {
        mixins: [clientPaginationMixin],
        components: {
            RouteBreadCrumb,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            Alert,
            flatPicker
        },
        computed: {
            ...mapGetters({
                    login: "login",
                    type: "type",
                    disqualified: "disqualified",
            })
        },
        data() {
            return {
                lang: this.$lang.report,
                fromMaxDate: new Date(),
                alertType: 'danger',
                successType: 'success',
                alertMessages: [],
                successMessages: [],
                loading: false,
                model: {
                    company: "",
                    site: [],
                    fromDate: "",
                    toDate: "",
                },
                selects: {
                    simple: "Select"
                },
                company: [],
                site: [],
                propsToSearch: ["CompanyName", "SiteName", "VisitorID", "VisitorName", "Surname", "EmailAddress", "DeviceName", "DeviceIdentifier", "VisitorRemark", "CellphoneNumber", "AccessDateTime", "BodyTemperature", "MemberName", "AllowShareInformation"],
                json_fields: {
                    'CompanyName': 'CompanyName',
                    'SiteName': 'SiteName',
                    'ID/Passport': 'VisitorID',
                    'VisitorName': 'VisitorName',
                    'VisitorSurname': 'Surname',
                    'MemberName': 'MemberName',
                    'VisitorEmail': 'EmailAddress',
                    'DeviceName': 'DeviceName',
                    'DeviceIdentifier': 'DeviceIdentifier',
                    'VisitorRemark': 'VisitorRemark',
                    'MobileNumber': 'CellphoneNumber',
                    'AccessDateTime': 'AccessDateTime',
                    'BodyTemperature': 'BodyTemperature',
                    'AllowShareInformation': 'AllowShareInformation',
                },
                selectedindex: 0,
                tableColumns: [
                    {
                        type: "selection"
                    }
                ],
                tableData: [],
                selectedRows: [],
                json_data: [],
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
                AccessDate: "",
                AccessTime: ""
            };
        },
        mounted() {
            let self = this;
            if (this.disqualified && this.disqualified.includes('Based')) {
                self.alertType = 'danger';
            } else {
                self.alertType = 'success';
            }
            if (this.disqualified) {
                self.alertMessages.push(self.disqualified);
                setTimeout(function () {
                    self.alertMessages = [];
                    self.$store.commit('setDisqualified', '');
                }, 5000)
            }
            this.companyList();
        },
        methods: {
            fromDateDisable(date) {
                return (this.model.toDate ? moment(date).format('DD-MM-YYYY') > this.model.toDate : date > moment());
            },
            toDateDisable(date) {
                return (this.model.fromDate ? moment(date).format('DD-MM-YYYY') < this.model.fromDate : date > moment());
            },
            selectionChange(selectedRows) {
                this.selectedRows = selectedRows;
            },
            onSubmit() {
                this.$router.push({path: "list"});
            },
            companyList() {
                this.loading = true;
                this.$store.dispatch('companyList').then(response => {
                    this.company = response.data;
//                    console.log('type',this.type);
                    if (this.type == 2 || this.type == 4 || this.type==6) {
                        this.model.company = this.login.CompanyID;
                        this.getSiteList(this.login.CompanyID);
                    } else {
                        this.loading = false;
                    }
                    /*if(this.type == 4){
                     this.model.site = this.login.CompanyID;
                     }*/
                    // this.siteList();
                });
            },
            getSiteList(val) {
                this.loading = true;
                this.site = [];
                this.model.site = [];
                let siteArr = new Array();
                this.$store.dispatch('getSiteUponCompany', val).then(response => {
                    if (this.type == 4) {
                        response.forEach((object) => {
                            siteArr = this.login.SiteIds.split(",");
                            if (siteArr.indexOf(object.ID.toString()) !== -1) {
                                this.site.push(object)
                            }
                        });
                    } else {
                        this.site = response;
                    }
                    this.loading = false;
                });
            },
            filterData() {
                this.loading = true;
                let data = {
                    "CompanyID": this.model.company,
                    "SiteID": this.model.site,
                    "From": moment(this.model.fromDate, "DD-MM-YYYY").format('YYYY-MM-DD'),
                    "To": moment(this.model.toDate, "DD-MM-YYYY").format('YYYY-MM-DD')
                };
//                this.model.site.forEach((object, index) => {
//                                        data.push('SiteID[' + index + ']', object);
//                                    });
                
                this.$store.dispatch('getReport', data)
                        .then(response => {
                            let res = response;
                            res.forEach((object, index) => {
                                response[index].AllowShareInformation = object.AllowShareInformation ? 'Yes' : (object.AllowShareInformation != undefined || object.AllowShareInformation != null ? 'No' : '');
                                console.log(response[index].AllowShareInformation);
                            });
                            console.log(response)
                            this.tableData = response;
                            this.json_data = response;
                            this.loading = false;
                        })
                        .catch(error => {
                            this.loading = false;
                        })
            },
            
        }
    };
</script>
<style>
    .no-border-card .card-footer {
        border-top: 0;
    }

    .modal-header {
        padding-bottom: 0;
    }
</style>
